import useContract from './useContract';
import StakingPool from '../contracts/HookableStakingPool.json';

const useEvilNoundleStakingPool = () =>
  useContract(
    process.env.NEXT_PUBLIC_EVIL_NOUNDLE_STAKING_POOL_CONTRACT_ADDRESS,
    StakingPool.abi
  );

export default useEvilNoundleStakingPool;
